import { BadgeWidget, Tooltip } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { draftIndicator } from './OmniboxV2Styles';

export function DraftTag(): JSX.Element {
    return <Tooltip tooltipContent={Messages.draftTagTooltip()} maxWidth={200}>
        <BadgeWidget
            className={draftIndicator}
            kind={'primary'}
            testId={`draft-tag`}>
            {Messages.draftTag()}
        </BadgeWidget>
    </Tooltip>
}